export const RECURRENCE_UNITS = {
  1: 'dia',
  7: 'semana',
  30: 'mês',
  60: 'bimestre',
  90: 'trimestre',
  180: 'semestre',
  365: 'ano',
};

export const RECURRENCE_LABELS = {
  1: 'diário',
  7: 'semanal',
  30: 'mensal',
  60: 'bimestral',
  90: 'trimestral',
  180: 'semestral',
  365: 'anual',
};
